// 跳转主页
export const gotoHome = () => {
    window.location.href = `//${window.location.host}`;
  };